import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  OnInit,
  Output,
  QueryList,
  ViewChildren,
} from '@angular/core';
import { Router } from '@angular/router';
import { LogedUser } from '@base/src/app/core/models/logged-user.model';
import { Constants } from '@base/src/app/models/constants';
import { QRButton } from '@base/src/app/models/qr-button.model';
import { QRChip } from '@base/src/app/models/qr-chip.model';
import { QRDialog } from '@base/src/app/models/qr-dialog.model';
import { QRInputAutocomplete } from '@base/src/app/models/qr-input-autocomplete.model';
import { QRInput } from '@base/src/app/models/qr-input.model';
import { QRToggle } from '@base/src/app/models/qr-toggle.model';
import { PropertyListingCaptured } from '@base/src/app/pages/listing-captured-form/models/property-listing-captured.model';
import { ListingSearchByAddressService } from '@base/src/app/pages/listing-captured-form/services/search-by-address.service';
import { ListingSearchByMlsidService } from '@base/src/app/pages/listing-captured-form/services/search-by-mlsid.service';
import { AgenciesListListingsService } from '@base/src/app/services/renditions/agencies-list-listings.service';
import { SnackbarService } from '@base/src/app/services/snackbar.service';
import { environment } from '@base/environments/environment';
import { InputAutocompleteWithServiceComponent } from '../../ui/input-autocomplete-with-service/input-autocomplete-with-service.component';

type InputTypes = string | number | undefined;

type OfficeModel = {
  id: number;
  name: string;
  office: string;
};
type SelectionType = number | string | { id: number; delete: number };
@Component({
  selector: 'app-reserve-selection',
  templateUrl: './reserve-selection.component.html',
  styleUrls: ['./reserve-selection.component.scss'],
})
export class ReserveSelectionComponent implements OnChanges, OnInit {
  @Input() reservations: {
    id: number;
    value: string;
    associatedDraft: number | null;
  }[] = [];
  @Input() reservationsListLoaded!: boolean;
  @Input() user: LogedUser | undefined;
  @Output() selection: EventEmitter<SelectionType> =
    new EventEmitter<SelectionType>();
  @Output() selectedPropListing: EventEmitter<PropertyListingCaptured> =
    new EventEmitter<PropertyListingCaptured>();

  originToggle: QRToggle = {
    hierarchy: QRToggle.HIERARCHY_2,
    size: QRToggle.SIZE_MEDIUM,
    viewValues: ['Reserva', 'Nueva'],
    optionSelected: 0,
  };

  //Toggle para elegir si buscar en listings o agregar una nueva
  originToggleLite: QRToggle = {
    hierarchy: QRToggle.HIERARCHY_2,
    size: QRToggle.SIZE_MEDIUM,
    viewValues: ['RE/MAX', 'Otra inmob.'],
    optionSelected: 0,
  };

  inputDirectionMlsId: QRInputAutocomplete = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Buscar',
    isCleanButtonVisible: true,
    options: [],
  };

  inputDirectionNew: QRInput = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Ingrese una dirección',
  };

  buttonConfirm: QRButton = {
    hierarchy: QRButton.HIERARCHY_2,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'Confirmar',
    icon: Constants.ICONS.CHECK_2,
  };

  reservation: {
    id: number;
    value: string;
    associatedDraft: number | null;
  } | null = null;
  newDirection: string | null = null;
  needsToLoad = false;

  dialogLoadDraft: QRDialog = {
    isVisible: false,
    width: '744px',
    height: '352px',
    title: '¿Cargar borrador?',
    textButtonAction: 'Cargar borrador',
    textButtonCancel: 'Eliminar borrador y volver a cargar desde la reserva',
    componentToLoad: QRDialog.DIALOG_RENDITION_FORM_LOAD_DRAFT,
    value: '',
  };

  autocompleteOfficeList: QRInputAutocomplete = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Ingrese el nombre de la oficina...',
    isCleanButtonVisible: true,
    options: [],
  };

  officeList: OfficeModel[] = [];
  officeSelected: OfficeModel | undefined;
  isLoadingOfficeList = false;

  userDataReceived = false;

  chipHierarchy2CleanButton: QRChip = {
    hierarchy: QRChip.HIERARCHY_2,
    size: QRChip.SIZE_SMALL,
    isCleanButtonVisible: true,
    icon: Constants.ICONS.HOME,
  };

  autocompleteMlsid: QRInputAutocomplete = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Ingrese un MLS-ID...',
    isCleanButtonVisible: false,
    options: [],
    value: undefined,
  };

  autocompleteAddress: QRInputAutocomplete = {
    mode: QRInput.MODE_STRING,
    hierarchy: QRInput.HIERARCHY_1,
    size: QRInput.SIZE_MEDIUM,
    placeholder: 'Ingrese una dirección...',
    isCleanButtonVisible: true,
    options: [],
    debounceTime: 500,
    value: undefined,
  };

  buttonSearchMLSID: QRButton = {
    hierarchy: QRButton.HIERARCHY_2,
    size: QRButton.SIZE_MEDIUM,
    icon: Constants.ICONS.SEARCH,
    iconOnly: true,
  };

  selectionBoxSearch: 0 | 1 = 0;

  mlsidWritten: string = '';
  mlsidSelected: string | undefined = '';
  addressSelected: string | undefined = '';

  isLoadingSearchService = false;
  searchResults: PropertyListingCaptured[] = [];
  propertySelected: PropertyListingCaptured | undefined = undefined;

  noResultsForMlsid: boolean | undefined = undefined;
  noResultsForAddress: boolean | undefined = undefined;

  buttonGoReservationForm: QRButton = {
    hierarchy: QRButton.HIERARCHY_1,
    size: QRButton.SIZE_MEDIUM,
    viewValue: 'CREAR RESERVA',
    icon: Constants.ICONS.HANDS,
  };
  buttonSearchCatchment: QRButton = {
    hierarchy: QRButton.HIERARCHY_2,
    size: QRButton.SIZE_SMALL,
    viewValue: 'Buscar captación',
    icon: Constants.ICONS.SEARCH,
  };
  noReserveResults = false;

  isLiteVersion = false; //Gestión LITE
  isVisibleSearchListing = false;
  readonly IS_AR = environment.node === Constants.TENANT_ID_AR;
  readonly IS_DO = environment.node === Constants.TENANT_ID_DO;
  readonly LISTINGS_SEARCH_ENABLED = this.IS_AR || this.IS_DO; //Que regiones tienen permitido buscar en listings

  @ViewChildren(InputAutocompleteWithServiceComponent)
  autocompleteServiceComponents!: QueryList<InputAutocompleteWithServiceComponent>;

  constructor(
    private readonly snackbarService: SnackbarService,
    private readonly router: Router,
    private readonly officeListListing: AgenciesListListingsService,
    private readonly searchByMlsidService: ListingSearchByMlsidService,
    private readonly searchByAddressService: ListingSearchByAddressService
  ) {}

  ngOnInit() {
    if (this.IS_DO)
      this.originToggleLite = {
        ...this.originToggleLite,
        viewValues: ['RE/MAX', 'Otro', 'Nueva'],
      };
  }

  ngOnChanges(): void {
    this.reservations.forEach((e: { id: number; value: string }) => {
      this.inputDirectionMlsId.options.push(e.value);
    });
    this.inputDirectionMlsId = { ...this.inputDirectionMlsId };

    if (this.user && !this.userDataReceived) {
      this.userDataReceived = true;
      this.isLiteVersion = this.user.lite;
      this.getOfficeList();
    }
  }

  //Es visible la búsqueda de captación en listings
  showSearchListings() {
    return (
      (this.isLiteVersion || this.isVisibleSearchListing) &&
      (this.IS_AR || this.IS_DO)
    );
  }

  //Mostrar más acciones cuando:
  //no encuentra reservas o cuando la oficina no tenga ninguna reserva
  showNoResultsReservations() {
    return (
      this.LISTINGS_SEARCH_ENABLED &&
      (this.noReserveResults ||
        (this.reservationsListLoaded && this.reservations.length === 0))
    );
  }

  onChangeOrigin($event: number) {
    this.originToggle.optionSelected = $event;
  }

  //Mostrar toggle origin para búsqueda en listings/maxcore
  showToggleOriginSearch(): boolean {
    switch (true) {
      case this.IS_AR:
        return this.originToggleLite.optionSelected === 0;

      case this.IS_DO:
        return (
          this.originToggleLite.optionSelected === 0 ||
          this.originToggleLite.optionSelected === 1
        );

      default:
        return this.originToggleLite.optionSelected === 0;
    }
  }

  //Toggle de origen que es ve cuando el usuario quiere buscar en listings
  onChangeOriginSearch() {
    this.officeSelected = undefined;
    this.propertySelected = undefined;
    this.mlsidSelected = undefined;
    this.addressSelected = undefined;
    this.clearInputsAutocompletes();
  }

  clearInputsAutocompletes(): void {
    const INPUTS = this.autocompleteServiceComponents?.toArray() ?? [];
    if (INPUTS?.length > 0) {
      INPUTS[0].clearInput();
      INPUTS[1].clearInput();
    }
  }

  selectMlsidOrAddress(value: 0 | 1) {
    if (this.selectionBoxSearch !== value) {
      this.clearInputsAutocompletes();
      this.propertySelected = undefined;
    }
    this.selectionBoxSearch = value;
  }

  directionMlsIdChange($event: string | undefined) {
    if ($event) {
      // Si la reserva tiene un borrador abrir dialogo ↓↓
      // this.openDialogLoadDraft($event);
      const reservation = this.reservations.find(
        (e: { id: number; value: string }) => $event == e.value
      );
      if (reservation) this.reservation = reservation;
    } else {
      this.reservation = null;
    }
  }

  changeInputDirectionNew($event: InputTypes) {
    this.newDirection = null;
    if ($event) this.newDirection = $event.toString();
  }

  onClickConfirm() {
    if (this.reservation?.associatedDraft) {
      // Abro dialogo
      this.openDialogLoadDraft(this.reservation);
      return;
    }

    let param: string | number | null | undefined = undefined;

    if (this.IS_AR) {
      param =
        this.originToggle.optionSelected === 1 ||
        this.originToggleLite.optionSelected === 1
          ? this.newDirection
          : this.reservation?.id;
    }
    if (this.IS_DO) {
      param =
        this.originToggle.optionSelected === 1 ||
        this.originToggleLite.optionSelected === 2
          ? this.newDirection
          : this.reservation?.id;
    }
    if (param) {
      this.needsToLoad = true;
      this.selection.emit(param);
    }
  }

  openDialogLoadDraft(reservation: {
    id: number;
    value: string;
    associatedDraft: number | null;
  }): void {
    this.dialogLoadDraft = {
      ...this.dialogLoadDraft,
      value: reservation,
      isVisible: true,
    };
  }

  dialogChangeLoadDraft($event: any): void {
    if ($event) {
      this.router.navigate(['renditions/edit/' + $event.associatedDraft]);
    } else {
      const PARAM = {
        id: this.dialogLoadDraft.value.id,
        delete: this.dialogLoadDraft.value.associatedDraft,
      };
      this.selection.emit(PARAM);
    }
  }

  //-------------------------------------------------
  //////////// BUSCADOR DE PROPIEDADES //////////////
  //-------------------------------------------------

  onChangeOriginLite($event: number) {
    this.originToggle.optionSelected = $event;
  }

  autocompleteOfficeListChanges(value: string | undefined): void {
    this.officeSelected = this.officeList.find((e) => e.name == value);
  }

  getOfficeList() {
    this.isLoadingOfficeList = true;
    this.officeListListing
      .get('')
      .then((response: any) => {
        this.isLoadingOfficeList = false;

        if (response?.data?.agencies) {
          this.officeList = response.data.agencies;

          if (this.officeList) {
            const LIST = this.officeList
              .filter((e) => e.office)
              .map((item) => item.name);
            LIST.sort((a, b) => a.localeCompare(b));
            this.autocompleteOfficeList = {
              ...this.autocompleteOfficeList,
              options: LIST,
            };
          }
        }
      })
      .catch(() => {
        this.isLoadingOfficeList = false;
      });
  }

  cleanChipOffice(e: string | number): void {
    this.officeSelected = undefined;
  }

  //------------🔍BUSQUEDA POR MLSID--------------

  //Mientras va escribiendo un mlsid
  mlsidForSearchChange(value: string): void {
    this.mlsidWritten = value;
  }

  onClickSearchByMlsid() {
    this.isLoadingSearchService = true;
    this.autocompleteMlsid = { ...this.autocompleteMlsid, options: [] };
    if (this.mlsidWritten) {
      this.onSearchByMlsidService(this.mlsidWritten);
    } else {
      this.isLoadingSearchService = false;
      this.noResultsForMlsid = undefined;
    }
  }

  //Cuando seleccionó un mlsid de la lista
  mlsidSelectedChange(value: string) {
    this.noResultsForMlsid = undefined;
    this.mlsidSelected = value;
    this.autocompleteMlsid = {
      ...this.autocompleteMlsid,
      isCleanButtonVisible: true,
      options: [],
    };
    this.findSelectedProperty(value, 'mlsid');
  }

  //-----------------🔍BUSQUEDA POR DIRECCION (origen: otra oficina)-----------------
  //Mientras va escribiendo un address
  addressForSearchChange(value: string | undefined): void {
    this.isLoadingSearchService = true;
    this.autocompleteAddress = { ...this.autocompleteAddress, options: [] };
    if (value) {
      this.onSearchByAddressService(value);
    } else {
      this.isLoadingSearchService = false;
      this.noResultsForAddress = undefined;
    }
  }

  //Cuando seleccionó un address de la lista (origen: otra oficina)
  addressSelectedChange(value: string) {
    this.noResultsForAddress = undefined;
    this.addressSelected = value;
    this.autocompleteAddress = {
      ...this.autocompleteAddress,
      isCleanButtonVisible: true,
      options: [],
    };
    this.findSelectedProperty(this.addressSelected, 'address');
  }

  // BUSQUEDA EN LISTINGS - MLSID - SERVICIO
  onSearchByMlsidService(mlsid: string) {
    let office = '';
    if (this.originToggleLite.optionSelected === 0) {
      office = this.officeSelected?.office ?? '';
    }
    if (this.IS_DO && this.originToggleLite.optionSelected === 1) {
      office = '-1';
    }

    const BODY = {
      office: office,
      param: mlsid,
    };

    this.searchByMlsidService
      .post(BODY, '')
      .then((response) => {
        this.isLoadingSearchService = false;
        if (response?.body?.data?.results?.length > 0) {
          this.searchResults = response.body.data.results;

          let listCustom: string[] = this.searchResults.map((e) => e.mlsid);
          this.autocompleteMlsid = {
            ...this.autocompleteMlsid,
            options: listCustom,
          };
          this.noResultsForMlsid = false;
        } else if (response.body.message) {
          this.noResultsForMlsid = true;
        }
      })
      .catch(() => {
        this.isLoadingSearchService = false;
        this.noResultsForMlsid = true;
        this.snackbarService.openSnackBar(
          '⛔ Ocurrió un error en la búsqueda por MLS-ID',
          ''
        );
      });
  }

  // BUSQUEDA EN LISTINGS - ADDRESS - SERVICIO
  onSearchByAddressService(address: string) {
    let office = '';
    if (this.originToggleLite.optionSelected === 0) {
      office = this.officeSelected?.office ?? '';
    }
    if (this.IS_DO && this.originToggleLite.optionSelected === 1) {
      office = '-1';
    }

    const BODY = {
      office: office,
      param: address,
    };

    this.searchByAddressService
      .post(BODY, '')
      .then((response) => {
        this.isLoadingSearchService = false;

        if (response?.body?.data?.results?.length > 0) {
          this.searchResults = response.body.data.results;

          let list: string[] = [];

          this.searchResults.forEach((e: PropertyListingCaptured) => {
            const ITEM = `${e.address} (${e.mlsid})`;
            list.push(ITEM);
          });

          this.autocompleteAddress = {
            ...this.autocompleteAddress,
            options: list,
          };
          this.noResultsForAddress = false;
        } else if (response.body.message) {
          this.noResultsForAddress = true;
        }
      })
      .catch(() => {
        this.isLoadingSearchService = false;
        this.noResultsForAddress = true;
        this.snackbarService.openSnackBar(
          '⛔ Ocurrió un error en la búsqueda por dirección.',
          ''
        );
      });
  }

  findSelectedProperty(
    selected: string | undefined,
    type: 'mlsid' | 'address'
  ) {
    if (selected) {
      //Si es direccion limpio el string y me quedo con el mlsid
      if (type == 'address') {
        selected = selected.substring(
          selected.lastIndexOf('(') + 1,
          selected.lastIndexOf(')')
        );
      }
      const RESULT = this.searchResults.find(
        (e: PropertyListingCaptured) => e.mlsid == selected
      );
      this.propertySelected = RESULT;
    }
  }

  goReserveForm() {
    this.router.navigate(['/nueva-reserva']);
  }

  //AR → confirma propiedad elegida del buscador en listings
  //DO → confirma propiedad elegida del buscador en Maxcore (Formato listings)
  onClickConfirmLite() {
    if (this.propertySelected) {
      this.selectedPropListing.emit(this.propertySelected);
      this.needsToLoad = true;
    }
  }
}
